const tr = {
  common: {
    loading: 'Yükleniyor...',
    online: 'Online',
    offline: 'Offline',
    status: 'Durum',
    weather: 'Hava Durumu',
    city: 'İl',
    town: 'İlçe',
    investor: 'Yatırımcı',
    name: 'Ad',
    eDay: 'Günlük Üretim',
    eTotal: 'Toplam Üretim',
    lastSeen: 'Son Veri',
    records: '{{count}} kayıt',
    plantsCount: '{{count}} santral',
    columns: 'Kolonlar',
    filters: 'Filtreler',
    close: 'Kapat',
    delete: 'Sil',
    refresh: 'Yenile',
    save: 'Kaydet',
    edit: 'Düzenle',
    cancel: 'İptal',
    powerStatus: 'Üretim Durumu',
    ftp: 'FTP',
    modbus: 'Modbus',
    serialNumber: 'S/N',
    months: {
      1: 'Ocak',
      2: 'Şubat',
      3: 'Mart',
      4: 'Nisan',
      5: 'Mayıs',
      6: 'Haziran',
      7: 'Temmuz',
      8: 'Ağustos',
      9: 'Eylül',
      10: 'Ekim',
      11: 'Kasım',
      12: 'Aralık',
    },
    monthsShort: {
      1: 'Oca',
      2: 'Şub',
      3: 'Mar',
      4: 'Nis',
      5: 'May',
      6: 'Haz',
      7: 'Tem',
      8: 'Ağu',
      9: 'Eyl',
      10: 'Eki',
      11: 'Kas',
      12: 'Ara',
    },
    weekdaysShort: {
      mon: 'Pzt',
      tue: 'Sal',
      wed: 'Çar',
      thu: 'Per',
      fri: 'Cum',
      sat: 'Cmt',
      sun: 'Paz',
    },
  },
  pvgis: {
    title: 'PVGIS Tahmin Analizi',
    subtitle: 'NASA/JRC PVGIS v5.3 Veri Seti',
    yearlyProduction: 'Yıllık Tahmini Üretim',
    averageIrradiation: 'Yıllık Ortalama Işınım',
    systemLoss: 'Toplam Sistem Kaybı',
    locationAndPower: 'Konum & Güç',
    monthlyProductionChart: 'Aylık Tahmini Üretim (kWh)',
    radiationTrendChart: 'Aylık Işınım Verileri (Son 24 Ay)',
    infoNote: 'PVGIS tahminleri panel eğimi 0° ve azimut 0° (Güney) varsayımıyla hesaplanmıştır.',
    horizontalRadiation: 'Yatay Işınım',
    optimalRadiation: 'Optimal Eğim Işınımı',
    kwhPerYear: 'kWh/yıl',
    kwhPerM2: 'kWh/m²',
    installedPower: 'kWp Kurulu Güç',
    loading: 'PVGIS verileri analiz ediliyor...',
    loadError: 'PVGIS verileri yüklenirken bir hata oluştu.',
    productionLabel: 'Üretim (kWh)',
    optimalAngle: 'Optimal Açı Önerisi',
    optimalTilt: 'Optimal Eğim (Tilt)',
    optimalAzimuth: 'Optimal Yön (Azimuth)',
    horizonProfile: 'Ufuk Profili (Gölgeleme Analizi)',
    shadingLost: 'Gölgeleme Kaybı',
    meteorologyStats: 'Tipik Meteorolojik Parametreler',
    airTemp: 'Ortalama Hava Sıcaklığı',
    windSpeed: 'Ortalama Rüzgar Hızı',
    pressure: 'Ortalama Atmosfer Basıncı',
    humidity: 'Ortalama Bağıl Nem',
    horizonHeight: 'Engeller Yüksekliği (°)',
    horizonAzimuth: 'Pusula Açısı (°)',
    degree: '°',
    lossAnalysis: 'Detaylı Kayıp Analizi',
    tempLoss: 'Sıcaklık & Düşük Işınım Kaybı',
    reflectionLoss: 'Açısal Yansıma Kaybı',
    shadingLoss: 'Ufuk (Gölge) Kaybı',
    miscLoss: 'Sabit Girdi Kaybı (Kablo/İnvertör)',
    totalLoss: 'Toplam Bileşik Kayıp',
    dailyProduction: 'Günlük Ortalama Üretim',
    refreshSuccess: 'Veriler PVGIS üzerinden güncellendi.',
  },
  language: {
    title: 'Dil',
    tr: 'Türkçe',
    en: 'English',
  },
  login: {
    brandTitle: 'GES Master',
    brandSubtitle: 'Güneş enerji santrallerinizi tek platformdan izleyin ve yönetin.',
    portalTitle: 'GES Master',
    title: 'Giriş Yap',
    description: 'Hesabınıza erişmek için bilgilerinizi girin.',
    welcome: 'Hoş geldin {{name}}',
    welcomeGeneric: 'Hoş geldin',
    email: 'E-posta',
    emailPlaceholder: 'ornek@sysenerji.net',
    password: 'Şifre',
    submit: 'Giriş Yap',
    submitting: 'Giriş yapılıyor...',
    invalidCredentials: 'E-posta veya şifre hatalı.',
    inactiveAccount: 'Hesabınız aktif değil.',
    genericError: 'Bir hata oluştu, lütfen tekrar deneyin.',
    backHome: 'Ana sayfaya dön',
    stats: {
      plants: 'Santral',
      inverters: 'İnverter',
      monitoring: 'İzleme',
    },
  },
  layout: {
    portal: 'Portal',
    unpinSidebar: 'Sabitlemeyi kaldır',
    pinSidebar: 'Menüyü sabitle',
    logout: 'Çıkış Yap',
    nav: {
      home: 'Ana Sayfa',
      powerPlants: 'Santraller',
      inverters: 'İnverterler',
      sites: 'Sahalar',
      investors: 'Yatırımcılar',
      maintenance: 'Bakım',
      sensors: 'Sensörler',
      alarms: 'Alarmlar',
      tasks: 'Görevler',
      agile: 'Proje',
      reports: 'Raporlar',
      management: 'Yönetim',
      automation: 'Otomasyon',
      monitoring: 'İzleme',
    },
  },
  management: {
    title: 'Yönetim',
    tabs: {
      users: 'Kullanıcılar',
      tags: 'Etiketler',
      settings: 'AI',
      parameters: 'Parametreler',
    },
    settingsPlaceholder: 'AI ayarları bu sekmede yönetilecektir.',
    parametersPlaceholder: 'Parametre yönetimini bu sekmede toplayacağız.',
    users: {
      title: 'Kullanıcılar',
      username: 'Kullanıcı Adı',
      fullname: 'Ad Soyad',
      email: 'E-posta',
      password: 'Şifre',
      passwordPlaceholder: 'Değiştirmek için yeni şifre girin',
      passwordHint: 'Şifre veritabanında hash olarak tutulur.',
      actions: 'İşlemler',
      active: 'Aktif',
      passive: 'Pasif',
      new: 'Yeni Kullanıcı',
      newTitle: 'Yeni Kullanıcı',
      editTitle: 'Kullanıcıyı Düzenle',
      save: 'Kaydet',
      cancel: 'İptal',
      loadError: 'Kullanıcı listesi yüklenemedi.',
      requiredError: 'Kullanıcı adı ve e-posta zorunludur.',
      passwordRequired: 'Yeni kullanıcı için şifre zorunludur.',
      createSuccess: 'Kullanıcı oluşturuldu.',
      createError: 'Kullanıcı oluşturulamadı.',
      updateSuccess: 'Kullanıcı güncellendi.',
      updateError: 'Kullanıcı güncellenemedi.',
      deleteSuccess: 'Kullanıcı silindi.',
      deleteError: 'Kullanıcı silinemedi.',
      deleteSelfError: 'Giriş yaptığınız kullanıcı silinemez.',
      duplicateError: 'Bu kullanıcı adı veya e-posta zaten kullanılıyor.',
      deleteConfirm: '{{name}} kullanıcısını silmek istediğinize emin misiniz?',
    },
    tags: {
      category: 'Etiket Kategorisi',
      label: 'Etiket Metni',
      color: 'Renk',
      createdOn: 'Oluşturulma',
      new: 'Yeni Etiket',
      newTitle: 'Yeni Etiket',
      editTitle: 'Etiketi Düzenle',
      editAssignments: 'Etiketleri düzenle',
      editAssignmentsTitle: 'Etiket Atamaları',
      assignmentHint: 'Bu nesneye bağlı etiketleri seçip çıkarabilirsiniz.',
      assignmentLoadError: 'Etiket atamaları yüklenemedi.',
      assignmentSaveSuccess: 'Etiket atamaları güncellendi.',
      assignmentSaveError: 'Etiket atamaları güncellenemedi.',
      noAssignedTags: 'Henüz etiket eklenmemiş.',
      noAvailableTags: 'Bu kategori için kullanılabilir etiket yok.',
      loadError: 'Etiket listesi yüklenemedi.',
      requiredError: 'Kategori, etiket metni ve renk zorunludur.',
      createSuccess: 'Etiket oluşturuldu.',
      createError: 'Etiket oluşturulamadı.',
      updateSuccess: 'Etiket güncellendi.',
      updateError: 'Etiket güncellenemedi.',
      deleteConfirm: '{{name}} etiketini silmek istediğinize emin misiniz?',
      deleteConfirmMessage: 'Bu işlem geri alınamaz.',
      deleteSuccess: 'Etiket silindi.',
      deleteError: 'Etiket silinemedi.',
      duplicateError: 'Bu kategori içinde aynı etiket zaten var.',
    },
  },
  maintenance: {
    title: 'Bakım Takibi',
    subtitle: 'İzleme, bakım, teklif ve sözleşme akışını tek modülde yönetin.',
    loadError: 'Bakım sözleşmeleri yüklenemedi.',
    detailLoadError: 'Sözleşme detayı yüklenemedi.',
    saveError: 'Sözleşme kaydedilemedi.',
    pdfError: 'PDF oluşturulamadı.',
    saving: 'Kaydediliyor...',
    deleteConfirm: 'Bu sözleşmeyi silmek istediğinize emin misiniz?',
    deleteConfirmMessage: 'Bu işlem geri alınamaz.',
    deleteSuccess: 'Sözleşme silindi.',
    deleteError: 'Sözleşme silinemedi.',
    titleShort: 'Bakım',
    new: 'Yeni Sözleşme',
    newTitle: 'Yeni Bakım Sözleşmesi',
    editTitle: 'Bakım Sözleşmesini Düzenle',
    modalSubtitle: 'Taslak sözleşme, teklif ve proforma akışını besleyecek sözleşme verisini burada tutuyoruz.',
    empty: 'Henüz bakım sözleşmesi bulunmuyor.',
    addLine: 'Santral Satırı Ekle',
    linesTitle: 'Santral Satırları',
    linesHint: 'Bir sözleşmeye birden fazla santral satırı ekleyebilirsiniz.',
    lineLabel: 'Santral Satırı {{index}}',
    summaryTitle: 'Özet',
    pdfActionsTitle: 'PDF Aksiyonları',
    documentsTitle: 'Dokümanlar',
    documentsEmpty: 'Henüz taslak sözleşme veya teklif dokümanı oluşturulmadı.',
    historyTitle: 'Geçmiş',
    historyEmpty: 'Henüz hareket kaydı yok.',
    cards: {
      totalContracts: 'Toplam Sözleşme',
      activeContracts: 'Aktif Sözleşme',
      expiringSoon: '30 Günde Bitenler',
      monthlyTotalUsd: 'Aylık USD',
      monthlyTotalTry: 'Aylık TL',
      yearlyTotalUsd: 'Yıllık USD',
      yearlyTotalTry: 'Yıllık TL',
    },
    filters: {
      allStages: 'Tüm Aşamalar',
      allInvestors: 'Tüm yatırımcılar',
      searchPlaceholder: 'Yatırımcı, santral veya referans kodu ara',
    },
    tabs: {
      contract: 'Sözleşme',
      plants: 'Santral',
    },
    table: {
      no: 'No',
      reference: 'Referans',
      investor: 'Yatırımcı',
      email: 'E-Posta',
      plants: 'Santraller',
      monthlyUsd: 'Aylık USD',
      monthlyTry: 'Aylık TL',
      yearlyUsd: 'Yıllık USD',
      yearlyTry: 'Yıllık TL',
      startDate: 'Başlangıç',
      durationYears: 'Süre',
      plantCount: '{{count}} santral',
      stage: 'Aşama',
      endDate: 'Bitiş',
      scope: 'Kapsam',
      installedPower: 'Güç',
      notes: 'Not',
      remaining: 'Kalan Süre',
      yearly: 'Yıllık Ücret',
    },
    remaining: {
      left: '{{count}} gün kaldı',
      overdue: '{{count}} gün geçti',
    },
    stage: {
      draft: 'Taslak',
      proposal: 'Teklif / Proforma',
      active: 'Aktif',
      expired: 'Süresi Doldu',
      canceled: 'İptal Edildi',
    },
    summary: {
      selectedInvestor: 'Yatırımcı',
      plantCount: 'Santral Sayısı',
      yearlyTry: 'Yıllık TRY',
      yearlyUsd: 'Yıllık USD',
    },
    pdf: {
      proposal: 'Teklif / Proforma PDF',
      agreement: 'İzleme Bakım Sözleşmesi PDF',
      open: 'Aç',
    },
    fields: {
      contractKind: 'Sözleşme Türü',
      stage: 'Aşama',
      investor: 'Yatırımcı',
      investorName: 'Yatırımcı Adı',
      referenceCode: 'Referans Kodu',
      location: 'Lokasyon',
      email: 'E-posta',
      phone: 'Telefon',
      startDate: 'Başlangıç Tarihi',
      durationYears: 'Geçerlilik (Yıl)',
      endDate: 'Bitiş Tarihi',
      scope: 'Sözleşme Kapsamı',
      vat: 'KDV Notu',
      notes: 'Not',
      powerPlant: 'Santral',
      powerPlantName: 'Santral Adı',
      installedPower: 'Santral Gücü',
      lineVat: 'Satır KDV Notu',
      monthlyUsd: 'Aylık Ücret (USD)',
      monthlyTry: 'Aylık Ücret (TL)',
      yearlyUsd: 'Yıllık Ücret (USD)',
      yearlyTry: 'Yıllık Ücret (TL)',
      lineNotes: 'Satır Notu',
    },
    form: {
      requiredInvestor: 'Yatırımcı adı zorunludur.',
      requiredPlant: 'En az bir santral satırı eklemelisiniz.',
      selectPowerPlant: 'Santral seçin',
    },
  },
  home: {
    loadError: 'Veriler yüklenemedi.',
    energy: {
      instant: 'Anlık Üretim',
      instantSub: 'Şu an online inverterlerin toplam aktif gücü',
      daily: 'Günlük',
      weekly: 'Haftalık',
      monthly: 'Aylık',
      yearly: 'Yıllık',
      lifetime: 'Toplam',
      dailySub: 'Günlük üretim',
      weeklySub: 'Son 7 gün',
      monthlySub: 'Bu ay',
      yearlySub: 'Bu yıl',
      lifetimeSub: 'Toplam üretim',
    },
    entities: {
      plant: 'Santral',
      inverter: 'İnverter',
      sensor: 'Sensör',
      active: 'Aktif',
      passive: 'Pasif',
      activeRatio: '%{{value}} aktif',
    },
    alarms: {
      title: 'Alarm',
      warning: 'Uyarı',
      minor: 'Minor',
      major: 'Major',
    },
    tasks: {
      title: 'Görev',
      todo: 'Yapılacak',
      progress: 'Devam',
      done: 'Tamam',
      cancel: 'İptal',
    },
    chart: {
      hourly: 'Saatlik',
      daily: 'Günlük',
      monthly: 'Aylık',
      yearly: 'Yıllık',
      switchRecharts: 'Recharts',
      switchHighcharts: 'Highcharts',
      rangeHourly: 'Son 24 saat (kWh)',
      rangeDaily: 'Son 30 gün (MWh)',
      rangeMonthly: 'Son 12 ay (MWh)',
      rangeYearly: 'Son 5 yıl (MWh)',
      tooltip: 'Üretim',
    },
    topPlants: {
      title: 'Bugün En Çok Üretim Yapan 10 Santral',
      subtitle: 'Günlük üretime göre sıralanmış canlı görünüm',
      power: 'Günlük üretim',
    },
    map: {
      show: 'Haritayı Göster',
      hide: 'Haritayı Gizle',
      title: 'Dünya Haritası',
      subtitle: '{{count}} santral seçili etiketlerle haritada gösteriliyor',
      detailTitle: 'Santral Detayı',
      detailHint: 'Haritadaki bir işarete tıklayarak canlı üretim bilgisini inceleyin.',
      tags: 'Etiketler',
      openPlant: 'Santral Detayına Git',
      empty: 'Haritada gösterecek koordinatlı santral bulunamadı.',
    },
    powerPlantTagFilterTitle: 'Power Plant Etiket Filtreleri',
    powerPlantTagFilterAll: 'Tüm Etiketler',
    powerPlantTagFilterEmpty: 'Atanmış etiket bulunamadı.',
  },
  powerPlants: {
    title: 'Santraller',
    loadError: 'Santral verileri yüklenemedi.',
    detailLoadError: 'Santral verisi yüklenemedi.',
    tagFilterTitle: 'Etiket Filtreleri',
    tagFilterPlaceholder: 'Etiket seç',
    tagFilterAll: 'Tüm Etiketler',
    tagFilterEmpty: 'Atanmış etiket bulunamadı.',
    tagFilterSelected: '{{count}} etiket seçili',
    location: 'Konum',
    weatherLoading: 'Yükleniyor…',
    forecast7Days: '7 Günlük Tahmin',
    weatherFetchedAt: 'Son alınma',
    humidity: 'Nem',
    wind: 'Rüzgar',
    pressure: 'Basınç',
    uv: 'UV',
    visibility: 'Görüş',
    sunriseShort: 'Gün. doğumu',
    inverter: 'İnverter',
    sensor: 'Sensör',
    alarm: 'Alarm',
    task: 'Görev',
    active: 'Aktif',
    passive: 'Pasif',
    contractStatus: {
      title: 'Sözleşme',
      active: 'Aktif',
      expiringSoon: '30 Günden Az',
      none: 'Yok',
    },
    instantPac: 'Anlık PAC',
    instantVoltage: 'Anlık Voltaj',
    instantCurrent: 'Anlık Akım',
    instantGeneration: 'Anlık Üretim',
    instantConsumption: 'Anlık Tüketim',
    daily: 'Günlük',
    weekly: 'Haftalık',
    monthly: 'Aylık',
    yearly: 'Yıllık',
    lifetime: 'Toplam',
  },
  automation: {
    title: 'İş Akışları & Otomasyon',
    openInNewTab: 'Arayüzü Aç (Yeni Sekme)',
    refresh: 'Yenile',
  },
  inverters: {
    title: 'İnverterler',
    titleWithPlant: '{{plant}} — İnverterler',
    count: '{{count}} inverter',
    loadError: 'İnverter verileri yüklenemedi.',
    inverter: 'İnverter',
    brand: 'Marka',
    model: 'Model',
    plant: 'Santral',
    dailyPower: 'Günlük Üretim',
    totalPower: 'Toplam Üretim',
  },
  investors: {
    title: 'Yatırımcılar',
    loadError: 'Yatırımcı verileri yüklenemedi.',
    detailLoadError: 'Yatırımcı detayı yüklenemedi.',
    name: 'Yatırımcı Adı',
    manager: 'Yönetici',
    managerName: 'Yönetici Adı',
    managerSurname: 'Yönetici Soyadı',
    plantCount: 'Santral Sayısı',
    email: 'E-posta',
    phone: 'Telefon',
    address: 'Adres',
    country: 'Türkiye',
    unknownManager: 'Bilinmeyen Yönetici',
    contactDetails: 'İletişim Bilgileri',
    powerPlants: 'Santraller',
    totalOnline: '{{total}} toplam · {{online}} online',
    edit: 'Düzenle',
    editTitle: 'Yatırımcıyı Düzenle',
    save: 'Kaydet',
    cancel: 'İptal',
    active: 'Aktif',
    passive: 'Pasif',
    delete: 'Sil',
    deleteConfirmTitle: 'Yatırımcıyı Sil',
    deleteConfirmMessage: 'Bu yatırımcıyı silmek istediğinize emin misiniz? Bu işlem geri alınamaz.',
    deleteError: 'Yatırımcı silinemedi.',
    saveError: 'Yatırımcı kaydedilemedi.',
    cannotDeleteWithPlants: 'Santrali olan yatırımcı silinemez',
    saveSuccess: 'Yatırımcı başarıyla kaydedildi.',
    deleteSuccess: 'Yatırımcı başarıyla silindi.',
    new: 'Yeni',
    newTitle: 'Yeni Yatırımcı',
    createSuccess: 'Yatırımcı başarıyla oluşturuldu.',
    createError: 'Yatırımcı oluşturulamadı.',
    nameRequired: 'Yatırımcı adı zorunludur.',
  },
  sensors: {
    title: 'Sensörler',
    loadError: 'Sensör listesi yüklenemedi.',
    detailLoadError: 'Sensör detayı yüklenemedi.',
    notFound: 'Sensör bulunamadı.',
    brandModelUnspecified: 'Marka/model belirtilmemiş',
    sensor: 'Sensör',
    powerPlant: 'Santral',
    brand: 'Marka',
    model: 'Model',
    serial: 'Seri No',
    pvTemp: 'PV Sıcaklığı',
    ambientTemp: 'Ortam Sıcaklığı',
    radiation: 'Radyasyon',
    windSpeed: 'Rüzgar Hızı',
    windDirection: 'Rüzgar Yönü',
    dailyIrradiation: 'Günlük Işınım',
    ftpStatus: 'FTP Durumu',
    modbusStatus: 'Modbus Durumu',
    usedInPlants: 'Kullanıldığı Santraller',
    connected: 'Bağlı',
    disconnected: 'Bağlı Değil',
  },
  tasks: {
    title: 'Görevler',
    board: 'Kanban',
    boardTitle: 'Görev Kanban',
    tabs: {
      kanban: 'Kanban',
      classic: 'Klasik',
    },
    filters: {
      all: 'Tüm Görevler',
      mine: 'Benim Görevlerim',
      allCategories: 'Tüm Kategoriler',
    },
    titleSingle: 'Görev',
    loadError: 'Görev listesi yüklenemedi.',
    detailLoadError: 'Görev detayı yüklenemedi.',
    notFound: 'Görev bulunamadı.',
    createTitle: 'Görev Oluştur',
    createButton: 'Görev Oluştur',
    new: 'Yeni',
    actions: 'İşlemler',
    duplicate: 'Kopyala',
    createRelated: 'İlişkili Görev Oluştur',
    creating: 'Oluşturuluyor...',
    createdSuccess: 'Görev oluşturuldu (#{{id}})',
    createError: 'Görev oluşturulamadı.',
    updateError: 'Görev güncellenemedi.',
    updatedSuccess: 'Görev güncellendi.',
    lookupsError: 'Görev lookup verileri yüklenemedi.',
    count: '{{count}} görev',
    id: '#',
    titleField: 'Başlık',
    powerPlant: 'Santral',
    category: 'Kategori',
    priority: 'Öncelik',
    description: 'Açıklama',
    created: 'Oluşturulma',
    due: 'Termin',
    done: 'Tamamlanma',
    assignees: 'Atananlar',
    createdBy: 'Oluşturan',
    attachments: 'Ekler',
    upload: 'Yükle',
    attachmentAdded: 'Dosya eklendi.',
    attachmentDeleted: 'Dosya silindi.',
    relationAdded: 'İlişki eklendi.',
    relationDeleted: 'İlişki kaldırıldı.',
    back: 'Geri',
    clear: 'Temizle',
    select: 'Seçiniz',
    categoryField: 'Görev Kategorisi',
    assigneesField: 'Görev Atananları',
    assigneesHelp: 'Birden fazla seçim için Ctrl/Cmd kullan.',
    titlePlaceholder: 'Görev başlığı...',
    descriptionPlaceholder: 'Görev açıklaması...',
    dueDate: 'Görev Termin Tarihi',
    attachmentFallback: 'ek',
    createModes: {
      duplicate: 'Kopya görev oluşturma',
      related: 'İlişkili görev oluşturma',
    },
    createModeDuplicateHelp: 'Mevcut görev bilgileri dolduruldu. Düzenleyip yeni görev olarak kaydedebilirsiniz.',
    createModeRelatedHelp: '{{task}} görevine bağlı yeni bir görev oluşturuyorsunuz. Kaydettiğinizde ilişki otomatik eklenecek.',
    status: {
      todo: 'Yapılacak',
      inProgress: 'Devam Ediyor',
      done: 'Tamamlandı',
      closed: 'Kapatıldı',
      canceled: 'İptal Edildi',
    },
    priorityLabel: {
      low: 'Düşük',
      middle: 'Orta',
      high: 'Yüksek',
    },
  },
  agile: {
    title: 'Proje',
    subtitle: 'Proje akışını tek yerden yönet',
    count: '{{count}} iş kartı',
    loadError: 'Agile board yüklenemedi.',
    newTask: 'Yeni Görev',
    createTitle: 'Yeni İş Kartı',
    createButton: 'Kart Oluştur',
    createSuccess: 'İş kartı oluşturuldu.',
    createError: 'İş kartı oluşturulamadı.',
    updateSuccess: 'İş kartı güncellendi.',
    updateError: 'İş kartı güncellenemedi.',
    delete: 'Sil',
    deleteSuccess: 'Görev silindi.',
    deleteError: 'Görev silinemedi.',
    deleteConfirm: 'Bu görevi silmek istediğinize emin misiniz?',
    deleteConfirmMessage: 'Bu işlem geri alınamaz.',
    movedSuccess: 'Kart yeni aşamaya taşındı.',
    moveError: 'Kart taşınamadı.',
    assignToMe: 'Üzerime Al',
    assignToMeSuccess: 'Kart üzerinize alındı.',
    actions: 'İşlemler',
    duplicate: 'Kopyala',
    createRelated: 'İlişkili Görev Oluştur',
    detailTitle: 'Kart Detayı',
    comments: 'Yorumlar',
    commentsShort: 'Yorum',
    history: 'Geçmiş',
    historyShort: 'Geçmiş',
    historyStatusChange: 'Aşama değişimi',
    historyAssigneeChange: 'Atanan değişimi',
    historyAttachmentAdd: 'Dosya eklendi',
    historyAttachmentDelete: 'Dosya silindi',
    historyRelationAdd: 'İlişki eklendi',
    historyRelationDelete: 'İlişki kaldırıldı',
    attachments: 'Ekler',
    attachmentsShort: 'Ek',
    relatedTasks: 'İlişkili Görevler',
    relatedTasksShort: 'İlişki',
    addRelation: 'İlişki Ekle',
    relatedTasksSearchPlaceholder: 'Görev ara ve ilişkilendir...',
    relatedTasksSearchHint: 'Aramaya başlamak için en az 2 karakter yazın.',
    relatedTasksNoResult: 'Eşleşen görev bulunamadı.',
    noRelatedTasks: 'Henüz ilişkili görev yok.',
    relationAddSuccess: 'Görev ilişkisi eklendi.',
    relationAddError: 'Görev ilişkisi eklenemedi.',
    relationDeleteSuccess: 'Görev ilişkisi kaldırıldı.',
    relationDeleteError: 'Görev ilişkisi kaldırılamadı.',
    relationDeleteConfirm: 'Bu görev ilişkisini kaldırmak istediğinize emin misiniz?',
    addAttachment: 'Dosya Ekle',
    noAttachments: 'Henüz ek yok.',
    preview: 'Önizle',
    attachmentUploadSuccess: 'Dosya yüklendi.',
    attachmentUploadError: 'Dosya yüklenemedi.',
    attachmentDeleteSuccess: 'Dosya silindi.',
    attachmentDeleteError: 'Dosya silinemedi.',
    attachmentDeleteConfirm: 'Bu eki silmek istediğinize emin misiniz?',
    commentPlaceholder: 'Görevle ilgili not veya güncelleme yazın...',
    addComment: 'Yorum Ekle',
    commentAdded: 'Yorum eklendi.',
    commentError: 'Yorum eklenemedi.',
    noMentionUsers: 'Eslesen kullanici bulunamadi.',
    noComments: 'Henüz yorum yok.',
    noHistory: 'Henüz aşama geçmişi yok.',
    unknownUser: 'Bilinmeyen kullanıcı',
    unassigned: 'Atanmamış',
    selectTaskType: 'Tür seçiniz',
    createdByLabel: 'Oluşturan',
    emptyColumn: 'Bu aşamada henüz kart yok.',
    requiredError: 'Başlık ve modül zorunludur.',
    createModes: {
      duplicate: 'Kopya kart oluşturma',
      related: 'İlişkili kart oluşturma',
    },
    createModeDuplicateHelp: 'Mevcut kart bilgileri dolduruldu. Düzenleyip yeni kart olarak kaydedebilirsiniz.',
    createModeRelatedHelp: '{{task}} kartına bağlı yeni bir kart oluşturuyorsunuz. Kaydettiğinizde ilişki otomatik eklenecek.',
    save: 'Kaydet',
    cancel: 'İptal',
    fields: {
      title: 'Başlık',
      description: 'Açıklama',
      module: 'Modül',
      taskType: 'Görev Türü',
      priority: 'Öncelik',
      assignee: 'Sorumlu',
      dueDate: 'Termin',
    },
    status: {
      todo: 'To Do',
      inProgress: 'In Progress',
      test: 'Test',
      done: 'Done',
      closed: 'Closed',
      canceled: 'Canceled',
    },
    priority: {
      low: 'Düşük',
      middle: 'Orta',
      high: 'Yüksek',
    },
    filters: {
      all: 'Tüm Görevler',
      mine: 'Benim Görevlerim',
      allModules: 'Tüm Modüller',
      allTaskTypes: 'Tüm Görev Türleri',
    },
  },
  monitoring: {
    queries: {
      statusSuccess: 'Başarılı',
      statusError: 'Hata',
      service: 'Servis',
      detailTitle: 'Detay / Execution Plan',
      startedAt: 'Başlangıç',
      duration: 'Süre',
      rows: 'Satır',
      params: 'Param',
      status: 'Durum',
      cacheHit: 'Cache Hit',
      cacheMiss: 'Cache Miss',
      hitRate: 'Hit %',
      ioMs: 'I/O ms',
      query: 'Sorgu',
      dayLabel: 'Gün:',
      noRecords: 'Henüz kayıt yok',
      todaySuffix: '(bugün)',
      totalQueries: 'Toplam Sorgu',
      avgDuration: 'Ort. Süre',
      longRunning: 'Uzun Çalışan',
      maxDuration: 'Maks. Süre',
      totalRows: 'Toplam Satır',
      errorLabel: 'Hata',
      errorRate: '%{{rate}} hata oranı',
      lastRefresh: 'Son güncelleme: {{time}}',
      records: '{{count}} kayıt',
      activeFilter: 'Filtre: {{filter}}',
      filterSlow: 'Uzun çalışan sorgular',
      filterError: 'Hatalı sorgular',
      refresh: 'Yenile',
      autoRefresh: 'Otomatik (5s)',
      clearButton: '{{date}} Temizle',
      clearConfirmTitle: '{{date}} loglarını temizle',
      clearConfirmMessage: 'Seçili güne ait sorgu logları silinecek.',
      cancel: 'Vazgeç',
      confirmClear: 'Evet, Temizle',
      clearSuccess: 'Sorgu logları temizlendi.',
      clearError: 'Sorgu logları temizlenemedi.',
    },
  },
  inverterDetail: {
    loadError: 'Veri yüklenemedi',
    notFound: 'Veri bulunamadı',
    activePower: 'Aktif Güç',
    daily: 'Günlük',
    total: 'Toplam',
    electrical: 'Elektriksel Veriler',
    strings: 'String Verileri',
    lastData: 'Son veri',
    voltageLineAB: 'Hat Gerilimi AB',
    voltageLineBC: 'Hat Gerilimi BC',
    voltageLineCA: 'Hat Gerilimi CA',
    currentPhaseA: 'Faz A Akımı',
    currentPhaseB: 'Faz B Akımı',
    currentPhaseC: 'Faz C Akımı',
    powerFactor: 'Güç Faktörü',
    reactivePower: 'Reaktif Güç',
    frequency: 'Frekans',
    temperature: 'Sıcaklık',
    stringCount: 'String Sayısı',
    capacity: 'Kapasite',
    chart: {
      title: 'Üretim Durumu',
      hourly: 'Saatlik',
      daily: 'Günlük',
      monthly: 'Aylık',
      yearly: 'Yıllık',
      rangeHourly: 'Son 24 saat · saatlik ({{unit}})',
      rangeDaily: 'Son 30 gün · günlük ({{unit}})',
      rangeMonthly: 'Son 12 ay · aylık ({{unit}})',
      rangeYearly: 'Son 5 yıl · yıllık ({{unit}})',
      tooltip: 'Üretim',
      stringPrefix: 'String',
    },
  },
} as const;

export default tr;
